angular.module(NgAppName).service('gGlobalVariables', [function() {

	this.vowImages = ['A', 'B', 'C']; 
	this.vowIndex = Math.floor(Math.random() * 3);

}]);
